var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.589844 19.7087C0.589843 30.5935 9.3048 39.4174 20.0552 39.4174C30.8057 39.4174 39.5206 30.5935 39.5206 19.7087C39.5206 8.8239 30.8057 4.73118e-07 20.0552 0C9.3048 -4.73118e-07 0.589844 8.82389 0.589844 19.7087ZM2.78932 19.7087C2.78932 29.3823 10.5312 37.203 20.0552 37.203C29.5793 37.203 37.3212 29.3823 37.3212 19.7087C37.3212 10.0351 29.5793 2.21446 20.0552 2.21446C10.5312 2.21446 2.78932 10.0351 2.78932 19.7087Z",
    fill: "#FF734F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10077 9.64149C8.66895 9.20673 7.96412 9.20751 7.5667 9.67432C2.26143 15.9058 2.56467 25.326 8.45772 31.2592C14.3508 37.1924 23.7072 37.4977 29.8966 32.1563C30.3602 31.7562 30.361 31.0465 29.9292 30.6118C29.5019 30.1816 28.8121 30.1834 28.3488 30.574C23.0302 35.0582 15.0579 34.7726 10.013 29.6934C4.96813 24.6141 4.68446 16.5875 9.13831 11.2326C9.52627 10.7662 9.52805 10.0717 9.10077 9.64149Z",
    fill: "#FF734F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7468 12.3057C11.3142 11.8701 10.6069 11.8707 10.22 12.3479C6.36178 17.1075 6.65526 24.1506 11.0868 28.6123C15.5184 33.074 22.5138 33.3695 27.2411 29.485C27.7152 29.0955 27.7158 28.3834 27.2831 27.9478C26.8566 27.5183 26.1694 27.5206 25.6942 27.8947C21.8408 30.9289 16.2262 30.6549 12.6421 27.0464C9.058 23.4379 8.78589 17.7851 11.7995 13.9054C12.1712 13.427 12.1734 12.7351 11.7468 12.3057Z",
    fill: "#FF734F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3952 14.972C13.9607 14.5346 13.2476 14.5358 12.8815 15.0327C10.4664 18.3111 10.7474 22.9764 13.7159 25.9652C16.6845 28.954 21.3183 29.2369 24.5745 26.8053C25.068 26.4368 25.0693 25.7188 24.6348 25.2813C24.2097 24.8534 23.5267 24.8578 23.0271 25.1943C20.654 26.7926 17.3937 26.5363 15.2712 24.3994C13.1487 22.2625 12.8942 18.9799 14.4816 16.5907C14.8159 16.0876 14.8203 15.4 14.3952 14.972Z",
    fill: "#FF734F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b85985abf2b2cbda258d7eadf1a8edb7.svg";
export { ForwardRef as ReactComponent };